'use client';
var ACTION_ITEM_VARIANTS = [
    "telegram",
    "call",
    "chat"
];

export { ACTION_ITEM_VARIANTS };
